export default __webpack_public_path__ + "static/media/04-observe.8f3c2611.png";